export const apiErrListeners: ((err: ApiError) => void)[] = [];
export const subscribeApiErr = (callback: (err: ApiError) => void) => {
  apiErrListeners.push(callback);
};

export const webapi = {
  post: async <T>(url: string, params: any, config?: any) => {
    let status = 0;
    let traceId = "";
    let code = 0;
    let msg = "";
    try {
      const resp = await fetch(url, {
        method: "post",
        body: JSON.stringify(params),
        credentials: "include",
        headers: config?.headers,
        signal: config?.signal,
      });
      status = resp.status;
      traceId = resp.headers.get("eas-trace-id") || "";

      const respData: {
        code: number;
        msg: string;
        data: T;
      } = await resp.json();
      code = respData.code;
      msg = respData.msg;

      if (code) {
        throw new Error(msg || "error code");
      }

      if (status < 200 || status >= 300) {
        throw new Error(msg || "error code");
      }

      return respData.data;
    } catch (e: any) {
      if (!msg) {
        msg = "message" in e ? e.message : e.toString();
      }
      const err = new ApiError(
        // AbortController的name为'AbortError' 需要通过name来区分
        typeof e.name === "string" ? (e.name as string) : "ApiError",
        msg,
        code,
        traceId,
        status,
      );
      apiErrListeners.forEach((cb) => cb(err));
      throw err;
    }
  },
  // 获取公共配置/数据接口
  getRaw: async <T>(url: string, params: Record<string, any>, config?: any) => {
    const urlParams = params ? new URLSearchParams(params).toString() : "";
    const resp = await fetch(`${url}${urlParams ? `?${urlParams}` : ""}`, {
      method: "get",
      headers: config?.headers,
      signal: config?.signal,
    });
    const respData: T = await resp.json();
    return respData;
  },
};

export class ApiError extends Error {
  code: number;
  traceId: string;
  status: number;
  constructor(
    name: string,
    msg: string,
    code: number,
    traceId: string,
    status: number,
  ) {
    super(msg);
    this.code = code;
    this.traceId = traceId;
    this.status = status;
    this.name = name;
  }
}
